import config from '../config';

export const getAvatarUrl = (coreClientId, avatar) => {
  if (!avatar) {
    return '';
  }

  if (!coreClientId) {
    const baseUrl = config['app.user_avatar.url'].resized_admin;
    return `${baseUrl}${avatar}`;
  }

  const baseUrl = config['app.user_avatar.url'].resized.replace(':clientId', coreClientId);
  return `${baseUrl}${avatar}`;
};



// WEBPACK FOOTER //
// ./src/utils/avatar.js